import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TPageType, IPage } from 'shared/types/page';

const initialState: IPage = { type: undefined };

export const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setPageType: (state, action: PayloadAction<TPageType | undefined>) => {
      state.type = action.payload;
    },
  },
});

export const {
  reducer: pageReducer,
  name: pageReducerName,
  actions: { setPageType },
} = pageSlice;
